import { api } from "../api/api";

const getDownloadPathAndSearch = (downloadUrl) => {
  const url = new URL(downloadUrl, window.location.origin);
  return `${url.pathname}${url.search}`;
};

export const createAuthenticatedDownloadUrl = async (downloadUrl) => {
  const response = await api.post(
    getDownloadPathAndSearch(downloadUrl).replace(
      "/api/files/download/binary",
      "/api/files/download/binary-ticket",
    ),
    null,
  );

  const ticketUrl = response.data?.url;
  if (!ticketUrl) {
    throw new Error("Download ticket response did not include url.");
  }

  const originalUrl = new URL(downloadUrl, window.location.origin);
  return new URL(ticketUrl, originalUrl).href;
};

const openAuthenticatedDownload = async (downloadUrl, targetWindow) => {
  const ticketUrl = await createAuthenticatedDownloadUrl(downloadUrl);

  if (targetWindow) {
    targetWindow.location.href = ticketUrl;
    return;
  }

  window.location.href = ticketUrl;
};

const openFallback = (downloadUrl, targetWindow) => {
  if (targetWindow) {
    targetWindow.location.href = downloadUrl;
    return;
  }

  window.open(downloadUrl, "_blank");
};

export const handleAuthenticatedDownload = async (
  e,
  downloadUrl,
  setLoading,
) => {
  e.preventDefault();
  const targetWindow = window.open("", "_blank");
  if (setLoading) setLoading(true);
  try {
    await openAuthenticatedDownload(downloadUrl, targetWindow);
  } catch {
    openFallback(downloadUrl, targetWindow);
  } finally {
    if (setLoading) setLoading(false);
  }
};

// Used by the /download/binary landing page (email links) after MSAL auth.
export const navigateToAuthenticatedDownload = async (downloadUrl) => {
  await openAuthenticatedDownload(downloadUrl);
};
